import React from "react";
import { Stack, Divider } from "@mui/material";
import { Images } from "../../../assets/common";

export default function ProfileSocialLinks({ twitter, instagram, tiktok }) {
  if (!twitter && !instagram && !tiktok) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-evenly"
      spacing={1}
      sx={{
        border: "0.5px solid #3E3E3E",
        borderRadius: "8px",
        height: "31px",
        width: "187px",
        marginTop: "20px",
      }}
    >
      {twitter && (
        <a
          href={twitter.includes("https://") ? twitter : `https://www.twitter.com/${twitter}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Images.twitter_t} height={15} width={15} alt="Twitter" />
        </a>
      )}
      {instagram && twitter && (
        <Divider sx={{ color: "#3E3E3E", height: "20px" }} orientation="vertical" />
      )}
      {instagram && (
        <a
          href={instagram.includes("https://") ? instagram : `https://www.instagram.com/${instagram}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Images.instagram} height={15} width={15} alt="Instagram" />
        </a>
      )}
      {tiktok && instagram && (
        <Divider sx={{ color: "#3E3E3E", height: "20px" }} orientation="vertical" />
      )}
      {tiktok && (
        <a
          href={tiktok.includes("https://") ? tiktok : `https://www.tiktok.com/${tiktok}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Images.tiktok} height={15} width={15} alt="TikTok" />
        </a>
      )}
    </Stack>
  );
}